export const state = {
  categories: []
}
